const FacilityCalendarAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const getBgColor = (type) => {
    let color = 'transparent';

    switch (type) {
      case 'facility_request':
        color = '#0ad251';
        break;
      case 'facility_operation':
        color = '#FC9131';
        break;
      case 'extrastock_offer':
        color = '#07a7e3';
        break;

      default:
        break;
    }

    return color;
  };

  const prepareData = (i) => ({
    ...i,
    backgroundColor: getBgColor(i.source_type),
    color: getBgColor(i.source_type),
    url: `/${i.source_type.split('_').join('/')}s/${i.source_id}/edit`,
    borderColor: 'transparent',
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }


  return prepareData(data);
};

export default FacilityCalendarAdapter;
